(function ($) {
  /**
   * Load more posts with AJAX.
   * Really simple. All you need is this JS and some HTML markup.
   *
   * Markup requirements:
   * .js-ajax-posts - outer wrapper for loop and pagination
   * .js-ajax-posts-loop - wrapper for actual posts loop, we will look for posts in this wrapper
   * .js-loop-cta - pagination wrapper
   * .js-ajax-load-posts - pagination button with link to next page
   *
   * Source: previous projects like Softec and Bratislavaman
   *
   */
  $('body').on('click', '.js-ajax-load-posts', function (e) {
    e.preventDefault();

    // while ajax is loading, do not allow running this script again
    if ($(this).hasClass('is-loading')) {
      return;
    }

    // Get next page link
    var $link = $(this).attr('href');
    var loading_text = $('.js-loop-cta').data('loading-text');
    var $btn = $(this);

    $.ajax({
      url: $link,
      context: $('.js-ajax-posts'), // Outer wrapper for ajax
      dataType: 'html',
      beforeSend: function () {
        $('.js-loop-cta').addClass('is-loading').text(loading_text); // Add loading class to pagination wrapper
        $btn.on('click', false); // Disable button click event
      },
      success: function (result) {
        // Append articles
        $('.js-ajax-posts-loop').append(
          $(result).find('.js-ajax-posts-loop article'),
        );

        // Append navigation
        $(this).append($(result).find('.js-loop-cta'));

        $('.js-loop-cta.is-loading').remove(); // Remove previous pagination wrapper

        $btn.off('click', false); // Re-enable button click event
      },
    });
  });
})(jQuery);
